export const isSensitiveLoginTokenPath = (pathname: string) => pathname.startsWith("/login/token/");
